import { render, staticRenderFns } from "./recruitStaffManage.vue?vue&type=template&id=6846e78c"
import script from "./recruitStaffManage.vue?vue&type=script&lang=js"
export * from "./recruitStaffManage.vue?vue&type=script&lang=js"
import style0 from "./recruitStaffManage.vue?vue&type=style&index=0&id=6846e78c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports